<template>
  <div class="RatioCropper">
    <div
      :style="{
        width: '100%',
        height: 0,
        paddingBottom: `${100 / ratio}%`,
        overflow: 'hidden',
        position: 'relative'
      }"
    >
      <api-picture
        :picture-id="pictureId"
        @rawLoad="handleLoad"
        @load="emitPictureObject"
        :update="update"
        :picture_class="pictureClass"
        :with_authors="with_authors"
        :lazy="lazy"
      ></api-picture>
    </div>
  </div>
</template>

<script>
import ApiPicture from "../Form/ApiPicture";
import { handleImageDimensions, ImageDimensions } from "../../util/func";

export default {
  name: "RatioCropper",
  components: { ApiPicture },
  data() {
    return {
      dim: ImageDimensions({})
    };
  },
  computed: {
    pictureClass() {
      if (this.dim.aspectRatio < this.ratio) return `RatioCropper__tooLarge`;
      if (this.dim.aspectRatio > this.ratio) return `RatioCropper__tooHigh`;
      return "";
    }
  },
  props: {
    ratio: {
      type: Number,
      // eslint-disable-next-line
      default: 1 / 1
    },
    update: {
      type: Boolean,
      default: false,
    },
    pictureId: {
      type: Number,
      default: null
    },
    with_authors: {
      type: Boolean,
      default: false,
    },
    lazy: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    emitPictureObject(event) {
      this.$emit('picture', event);
    },
    handleLoad(e) {
      this.dim = handleImageDimensions(e.target);
    }
  }
};
</script>

<style lang="scss">
.RatioCropper {
  width: 100%;
  position: relative;
  &__tooLarge,
  &__tooHigh {
    position: absolute;
    top: 0;
    left: 0;
    max-width: none;
  }

  &__tooLarge {
    width: 100%;
    height: auto;
    transform: translateY(-50%);
    top: 50%;
  }

  &__tooHigh {
    height: 100%;
    width: auto;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>
